import { Credentials, BasicCredentials, TokenCredentials, CredentialsType, CustomHeaders, AwsSignatureCredentials } from "../interfaces/credentials/Credentials";
import { CredentialsReferenceType } from "../interfaces/flow/action/WebRequestAction";

export const createCredObject = (name: string, type: string) => {
  let cred: Credentials = { name: name, clientKey: "", type: type === undefined ? CredentialsType.BASIC_AUTH : type };
  switch (type) {
    case CredentialsType.BASIC_AUTH:
      cred.data = { username: "", password: "" } as BasicCredentials;
      break;
    case CredentialsType.TOKEN:
      cred.data = { token: "" } as TokenCredentials;
      break;
    case CredentialsType.CUSTOM_HEADER:
      cred.data = { headers: [] } as CustomHeaders;
      break;
    case CredentialsType.AWS_SIGNATURE:
      cred.data = {
        accessKey: "",
        secretKey: "",
        region: "",
        service: "",
        sessionToken: "",
      } as AwsSignatureCredentials;
      break;
    default:
      break;
  }
  return cred;
};
/**
 * Used to make credentials object to store on actions
 */
export const createCredRef =(credentialId:string)=>{
  return {
    value:credentialId,
    type:CredentialsReferenceType.DATABASE_REF
  }
}
